export default __webpack_public_path__ + "static/media/agave-tequila.2f5f69ce.png";